import Vue from 'vue';
import App from './App.vue';

//三方库
import router from "./router";
import Router from "vue-router";
//公共样式
import "./assets/style/index.scss";
// 视频样式
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
//重写router.push
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
//阿里字体图标混入Ant Design Vue中的icon
//这个iconfont.js就是从iconfont.cn网站上下载后的解压JS文件
import "./assets/iconfonts/iconfont.css"; //字体图标
import iconFront from "./assets/iconfonts/iconfont.js"; //字体图标js
import { Icon } from "ant-design-vue";
const alicon = Icon.createFromIconfontCN({
  scriptUrl: iconFront,
});
Vue.component("alicon", alicon);
import store from "./store";
Vue.prototype.$store = store;

//UI框架
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);

// 插件
import "signalr";
import "./assets/plugins/quill-editor";
//swiper轮播
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import * as moment from 'moment';
Vue.prototype.moment = moment;

// echarts图表
import *as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// 富文本编辑器
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

// 全局配置及工具函数
import * as utils from "./assets/js/utils";
Vue.prototype.$utils = utils;
import config from "./assets/js/config";
Vue.prototype.$config = config;
import api from "./common/api"; //引入请求函数
Vue.prototype.$api = api;

// 腾讯视频播放器
// import VTcPlayer from 'v-tcplayer';
// Vue.use(VTcPlayer,{name: 'VTcPlayer'})

import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
Vue.prototype.TcPlayer = TCPlayer

// DPlayer播放器
window.Hls = require('hls.js')
import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'
Vue.use(VueDPlayer)

// 配置字体
import '@/assets/font/font.css'

Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
